import * as keyapis_iot_connect_v1_callback_pb from "./v1/keyapis_iot_connect_callback_v1.pb";
import * as keyapis_iot_connect_v1_manage_pb from "./v1/keyapis_iot_connect_manage_v1.pb";
import * as keyapis_iot_connect_v1_system_pb from "./v1/keyapis_iot_connect_system_v1.pb";

export default {
  v1: {
    resources: {
      callback: keyapis_iot_connect_v1_callback_pb,
      manage: keyapis_iot_connect_v1_manage_pb,
      system: keyapis_iot_connect_v1_system_pb,
    },
  },
};
